import React from 'react';

import { formatImgUrl, jFileLittle } from 'jamespot-user-api';

import { JRCFileImage } from 'components/JRCFile/JRCFileImage';

import styled from 'styled-components';
import { JRCLoader } from 'components/JRCLoader/JRCLoader';

const MAX_SIZE = 200;

export const CSSRowImageWrapper = styled.button<{ margin: number }>`
    left: ${(props) => props.margin}px;
    max-width: ${MAX_SIZE}px;
    position: relative;
    border-radius: ${({ theme }) => theme.space.sm}px;
    overflow: hidden;
    margin-bottom: ${({ theme }) => theme.space.sm}px;
    img {
        width: 100%;
    }
    .background {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        inset: 0;
        background-color: ${({ theme }) => theme.color.grey6};
        opacity: 0;
    }
    .cross {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        inset: 0;
        background-color: transparent;
        color: ${({ theme }) => theme.color.orange};
        font-size: 24px;
        opacity: 0;
    }

    &:hover {
        .cross {
            opacity: 1;
        }
        .background {
            opacity: 0.8;
        }
    }
`;

export const JRCWidgetCheckListImage = ({
    file,
    margin = 0,
    onClick,
    handleRemove,
}: {
    file: jFileLittle;
    margin?: number;
    onClick?: () => void;
    handleRemove?: () => void;
}) => {
    return file ? (
        <CSSRowImageWrapper onClick={handleRemove ?? onClick} margin={margin}>
            <JRCFileImage
                mimetype={file.mimetype}
                size={MAX_SIZE}
                uri={formatImgUrl({
                    size: 'original',
                    from: 'imagecache',
                    uri: file.uri,
                })}
            />
            {handleRemove && <div className="background"></div>}
            {handleRemove && <div className="cross">&times;</div>}
        </CSSRowImageWrapper>
    ) : (
        <JRCLoader size={'s'} />
    );
};
